import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { LLMSettingsPage } from '../pages/LLMSettingsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/settings-ai' as any)({
  component: () => (
    <MainLayout>
      <LLMSettingsPage />
    </MainLayout>
  ),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: '/login' })
  },
})
